/* eslint-disable*/

var checkSoaFMSubscription = function checkSoaFMSubscription(
  selectedLevel,
  exam_data
) {
  // console.log(" FM selectedLevel", selectedLevel);
  // console.log(" Fm exam_data", exam_data);
  var flag = false;
  for (var i = 0; i < exam_data.length; i++) {
    // console.log("1");

    if (exam_data[i].exam_name === selectedLevel) {
      // console.log("2");
      if (exam_data[i].levels.length) {
        // console.log("3");
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          // console.log("4");
          if (exam_data[i].levels[j].isActive) {
            // console.log("5");
            flag = true;
            break;
          }
        }
      } else {
        // console.log("6");
        flag = true;
      }
      break;
    } else {
      // console.log("7");
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === "unlimited" &&
            (exam_data[i].levels[j].package_id === 28 ||
              exam_data[i].levels[j].package_id === 34 ||
              exam_data[i].levels[j].package_id === 36)
          ) {
            flag = true;
            break;
          } else if (
            exam_data[i].levels[j].isActive &&
            exam_data[i].levels[j].package_id === 35
          ) {
            flag = true;
            break;
          }
        }
      }
    }
  }
  return flag;
};

var checkSoaFMNotesSubscription = function checkSoaFMNotesSubscription(
  selectedLevel,
  exam_data
) {
  var flag = false;

  var pdfFlag = false;
  for (var i = 0; i < exam_data.length; i++) {
    // console.log("1");

    if (exam_data[i].exam_name === selectedLevel) {
      // console.log("2");
      if (exam_data[i].levels.length) {
        // console.log("3");
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === "expensive" &&
            exam_data[i].levels[j].isActive
          ) {
            flag = true;
            break;
          } else if (
            exam_data[i].levels[j].package_val === "simple" &&
            exam_data[i].levels[j].isActive &&
            exam_data[i].levels[j].noteStatus !== false
          ) {
            flag = true;
            break;
          } else if (
            exam_data[i].levels[j].package_val === "unlimited" &&
            exam_data[i].levels[j].isActive
          ) {
            flag = true;
            break;
          }
        }
      } else {
        // console.log("6");
        flag = true;
      }
      // break;
    } else {
      // console.log("7");
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === "unlimited" &&
            (exam_data[i].levels[j].package_id === 28 ||
              exam_data[i].levels[j].package_id === 34 ||
              exam_data[i].levels[j].package_id === 36)
          ) {
            flag = true;
            break;
          } else if (
            exam_data[i].levels[j].isActive &&
            exam_data[i].levels[j].package_id === 35 &&
            exam_data[i].levels[j].noteStatus !== false
          ) {
            flag = true;
            break;
          }
        }
      }
    }
  }

  return flag;
};

var checkSoaFM_PDFSubscription = function checkSoaFM_PDFSubscription(
  selectedLevel,
  exam_data,
  type
) {
  // console.log("selectedLevel FM PDF", selectedLevel);/
  // console.log("exam_data FM PDF", exam_data);/*  */

  var pdfFlag = false;
  for (var i = 0; i < exam_data.length; i++) {
    // console.log("1");
    //
    if (exam_data[i].exam_name === selectedLevel) {
      // console.log("2");
      if (exam_data[i].levels.length) {
        // console.log("3");
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === "expensive" &&
            exam_data[i].levels[j].isActive
          ) {
            pdfFlag = true;
            // break;
          } else if (
            exam_data[i].levels[j].package_val === "simple" &&
            exam_data[i].levels[j].isActive
          ) {
            if (exam_data[i].levels[j].pdfstatus && type === "question") {
              pdfFlag = true;
            } else if (exam_data[i].levels[j].noteStatus && type === "notes") {
              pdfFlag = true;
            }
            // break;/
          } else if (
            exam_data[i].levels[j].package_val === "unlimited" &&
            exam_data[i].levels[j].isActive
          ) {
            pdfFlag = true;
            // break;
          }
        }
      } else {
        // console.log("6");
        pdfFlag = true;
      }
      // break;
    } else {
      // console.log("7");
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === "unlimited" &&
            (exam_data[i].levels[j].package_id === 28 ||
              exam_data[i].levels[j].package_id === 34 ||
              exam_data[i].levels[j].package_id === 36)
          ) {
            pdfFlag = true;
            // break;
          } else if (
            exam_data[i].levels[j].isActive &&
            exam_data[i].levels[j].package_id === 35
          ) {
            if (exam_data[i].levels[j].pdfstatus && type === "question") {
              pdfFlag = true;
            } else if (exam_data[i].levels[j].noteStatus && type === "notes") {
              pdfFlag = true;
            }
            // break;
          }
        }
      }
    }
  }

  return pdfFlag;
};

var checkSoaFMVideosSubscription = function checkSoaFMVideosSubscription(
  selectedLevel,
  exam_data
) {
  var flag = false;
  for (var i = 0; i < exam_data.length; i++) {
    if (exam_data[i].exam_name === selectedLevel) {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === "expensive" &&
            exam_data[i].levels[j].isActive
          ) {
            flag = true;
            // break;
          } else if (
            exam_data[i].levels[j].package_val === "simple" &&
            exam_data[i].levels[j].isActive &&
            exam_data[i].levels[j].videoStatus !== false
          ) {
            flag = true;
            // break;/
          } else if (
            exam_data[i].levels[j].package_val === "unlimited" &&
            exam_data[i].levels[j].isActive
          ) {
            flag = true;
            // break;
          }
        }
      } else {
        flag = true;
      }
      // break;
    } else {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === "unlimited" &&
            (exam_data[i].levels[j].package_id === 28 ||
              exam_data[i].levels[j].package_id === 34 ||
              exam_data[i].levels[j].package_id === 36)
          ) {
            flag = true;
            break;
          }
        }
      }
    }
  }
  return flag;
};
exports.checkSoaFMSubscription = checkSoaFMSubscription;
exports.checkSoaFMNotesSubscription = checkSoaFMNotesSubscription;
exports.checkSoaFM_PDFSubscription = checkSoaFM_PDFSubscription;
exports.checkSoaFMVideosSubscription = checkSoaFMVideosSubscription;



// WEBPACK FOOTER //
// ./src/views/RestAPI/SoaFMSubscription.js